module.exports = __webpack_public_path__ + "img/hills.9e50b678.png";